/* Galerie & Kunsthaus Nottbohm — 3D-Modelle
   Shopify zeigt 3D-Modelle über <model-viewer>. Voreingestellt lässt sich
   die Figur in alle Richtungen kippen, was bei einer stehenden Skulptur
   unruhig wirkt. Hier wird die Drehung auf die Waagerechte begrenzt:
   Der Blickwinkel bleibt auf Augenhöhe, gedreht wird nur um die Hochachse.
   Nicht Teil des Impression-Themes.
*/
(function () {
	"use strict";

	var WINKEL = "78deg";   // Blickhöhe: 90deg wäre exakt seitlich

	function begrenzen() {
		var betrachter = document.querySelectorAll("model-viewer:not([data-nb-3d])");
		Array.prototype.forEach.call(betrachter, function (mv) {
			mv.setAttribute("data-nb-3d", "1");

			// Kippen nach oben und unten unterbinden
			mv.setAttribute("min-camera-orbit", "auto " + WINKEL + " auto");
			mv.setAttribute("max-camera-orbit", "auto " + WINKEL + " auto");
			mv.setAttribute("camera-orbit", "0deg " + WINKEL + " auto");

			// Zoom maßvoll halten, Figur bleibt vollständig im Bild
			mv.setAttribute("min-field-of-view", "22deg");
			mv.setAttribute("max-field-of-view", "38deg");

			// Sanfte Eigendrehung, bis der Besucher selbst dreht
			mv.setAttribute("auto-rotate", "");
			mv.setAttribute("auto-rotate-delay", "1200");
			mv.setAttribute("rotation-per-second", "18deg");
			mv.setAttribute("interaction-prompt", "none");
		});
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", begrenzen);
	} else {
		begrenzen();
	}

	window.addEventListener("load", begrenzen);

	if (window.MutationObserver) {
		var wartet = false;
		new MutationObserver(function () {
			if (wartet) return;
			wartet = true;
			window.setTimeout(function () { wartet = false; begrenzen(); }, 400);
		}).observe(document.body, { childList: true, subtree: true });
	}
})();
